import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { SearchFilterService } from '../../_services';
import { PageLinkModel } from '../../_interfaces/page-link/page-link.model';

declare var dataLayer: any;

@Component({
  selector: 'pq-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./_pagination.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaginationComponent implements OnInit {
  public displayPaginationLinks: Object[] = [];
  public previousPage: PageLinkModel = {
    link: {
      page: undefined
    },
    active: false
  };
  public nextPage: PageLinkModel = {
    link: {
      page: undefined
    },
    active: false
  };
  public displayPagination: boolean = false;

  @Input() public currentPage: number = 1;
  @Input() public total: number = 0;
  @Input() public queryParam: Object = {};
  @Input() public numberPerPage: string = '10';
  @Input() public profile: string = '';

  private _paginationLinks: Object[] = [];
  private _totalPages: number = 1;
  private _numPages: number = 5;

  constructor (private _searchFilterSvc: SearchFilterService) {}

  public ngOnInit () {
    // clone the query params for updating for individual links
    const baseParams = JSON.parse(JSON.stringify(this.queryParam));

    if (this.queryParam['resultsToShow']) {
      this.numberPerPage = this.queryParam['resultsToShow'];
    }

    let numToShow = parseInt(this.numberPerPage, 0);

    if (this.queryParam['page']) {
      this.currentPage = parseInt(this.queryParam['page'], 0);
    }
    // total results is greater then number of results per page
    if (this.total > numToShow) {
      this.displayPagination = true;
      this._totalPages = Math.ceil(this.total / numToShow);

      this._paginationLinks = this.createPaginationLinks(this._totalPages, numToShow, baseParams);

      // limit the number of pages displayed on the screen to 5
      if (this._paginationLinks.length > this._numPages) {
        // middle pages should include 2 links in front of the selected page and 2 pages after the selected page
        let links = this._paginationLinks.slice((this.currentPage - 3), (this.currentPage + 2));

        // exception is the first two pages
        if (this.currentPage < 3) {
          links = this._paginationLinks.slice(0, this._numPages);
        }

        // the the collection of pages equals 5 then use it for the display, if not grab the last five pages and use it
        if (links.length === this._numPages) {
          this.displayPaginationLinks = links;
        } else {
          this.displayPaginationLinks = this._paginationLinks.slice(-1 * this._numPages);
        }
      } else {
        this.displayPaginationLinks = this._paginationLinks;
      }

      // create previous page link data
      this.previousPage = this._paginationLinks[this.currentPage - 2]
        ? JSON.parse(JSON.stringify(this._paginationLinks[this.currentPage - 2])) : { link: {} };

      if (this.previousPage['link'] && this.previousPage['link']['page']) {
        this.previousPage['active'] = true;
      } else {
        this.previousPage['active'] = false;
      }

      // create next page link data
      this.nextPage = this._paginationLinks[this.currentPage]
        ? JSON.parse(JSON.stringify(this._paginationLinks[this.currentPage])) : { link: {} };

      if (this.nextPage['link'] && this.nextPage['link']['page'] && this._paginationLinks.length >= parseInt(this.nextPage['link']['page'])) {
        this.nextPage['active'] = true;
      } else {
        this.nextPage['active'] = false;
      }

    }
  }

  public createPaginationLinks (total, num, baseParams): Object[] {
    let paginationLinks = [];

    // remove page param if need be
    if (baseParams['page']) {
      delete baseParams['page'];
    }

    // set default value for page
    baseParams['page'] = 1;

    let page =  0;
    let offset;

    while (total) {
      let data = {};
      // clone base params, so that individual object keep state of their property values outside of the loop
      let link = JSON.parse(JSON.stringify(baseParams));

      page = page + 1;
      offset = page === 1 ? 0 : (offset + num);

      link['page'] = page;
      link['offset'] = offset;

      if (!baseParams['sort']) {
        link['sort'] = this._searchFilterSvc.getDefaultSortBy();
      }

      data['active'] = this.currentPage === page;
      data['link'] = link;

      paginationLinks.push(data);

      total--;
    }

    return paginationLinks;
  }

  public pushPageNavToGA(pageNum: string) {
    if (dataLayer && Array.isArray(dataLayer)) {
      dataLayer.push({'event': 'ResultsPageNavigation', 'label': pageNum});
    }
  }
}
